import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import Page from '@Containers/Page';
import Button from '@Components/Button';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import { supportCenterLink } from './LoginLimitConstants';

function LoginLimit({ message }) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);

  return (
    <Page withHeader headerType="clean" withFooter pageClassName="login-limit-page" className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <svg className="els-btn-icon-md">
          <use xlinkHref="#icon-cog" />
        </svg>
        &nbsp; Too many current active logins.
      </h1>
      <div className="react-page-static__content">
        <p>{message}</p>
        <p>
          <Button
            buttonConfig={{
              label: 'Contact Support Team',
              aTag: true,
              target: '_blank',
              href: supportCenterLink,
              type: 'link',
              size: 'sm',
              e2eName: 'contact-support-team',
            }}
            iconConfig={{
              name: 'chevron-right',
            }}
          />
        </p>
      </div>
    </Page>
  );
}

LoginLimit.propTypes = {
  message: PropTypes.string,
};

export default withCombinedRouteParams(LoginLimit);
